export const MITRA_PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.loksy.mitra&hl=en_IN";

export const MITRA_DASHBOARD_URL = "https://loksy.in/locsydashboard";

export const MITRA_SPLASH_SCREENS = [
  {
    id: "campaign",
    image: "/images/loki/loki_intro.png",
    en: {
      title: "Your Business. Your Customers. Your Growth.",
      body: "One character. Many roles. Always your guide.",
    },
    te: {
      title: "మీ వ్యాపారం… మీ కస్టమర్లు… మీ ఎదుగుదల — అన్నీ Loksyతో!",
      body: "ఒక్క పాత్ర • ఎన్నో రోల్స్ • ఎప్పుడూ మీ గైడ్!",
    },
    hi: {
      title: "आपका बिज़नेस… आपके ग्राहक… आपकी तरक्की — सब Loksy के साथ!",
      body: "एक किरदार • कई भूमिकाएँ • हमेशा आपका गाइड!",
    },
  },
  {
    id: "local-global",
    image: "/images/loki/loki_discover.png",
    en: {
      title: "From Local to Global — Your Business Has No Limits!",
      body: "With Loksy, take your business from your town to the world.",
    },
    te: {
      title: "🌍 Local నుంచి Global వరకు… మీ Businessకి హద్దులు లేవు!",
      body: "Loksyతో మీ వ్యాపారాన్ని మీ ఊరి నుంచి ప్రపంచం వరకు తీసుకెళ్లండి.",
    },
    hi: {
      title: "🌍 Local से Global तक… आपके Business की कोई हद नहीं!",
      body: "Loksy के साथ अपने बिज़नेस को अपने शहर से दुनिया तक ले जाएँ।",
    },
  },
  {
    id: "shop",
    image: "/images/loki/loki_shop.png",
    en: {
      title: "Create Your Digital Shop",
      body: "Showcase your products, services, offers and more in one digital place.",
    },
    te: {
      title: "మీ షాప్‌కు డిజిటల్ అడ్రస్ ఇవ్వండి!",
      body: "మీ ఉత్పత్తులు, సేవలు, ఆఫర్లు, ఫోటోలు—అన్నీ ఒకే డిజిటల్ పేజీలో చూపించండి.",
    },
    hi: {
      title: "अपनी दुकान को डिजिटल पता दें!",
      body: "अपने प्रोडक्ट, सेवाएँ, ऑफ़र और फ़ोटो—सब एक डिजिटल पेज पर दिखाएँ।",
    },
  },
  {
    id: "leads",
    image: "/images/loki/loki_leads.png",
    en: {
      title: "Get More Customer Enquiries",
      body: "Let customers looking for your services connect with you directly.",
    },
    te: {
      title: "కస్టమర్లే మిమ్మల్ని వెతుక్కుంటూ వస్తారు!",
      body: "మీ సేవల కోసం వెతికే కస్టమర్ల నుంచి నేరుగా Calls, Enquiries & Leads పొందండి.",
    },
    hi: {
      title: "ग्राहक खुद आपको ढूँढकर आएँगे!",
      body: "आपकी सेवाएँ खोज रहे ग्राहकों से सीधे Calls, Enquiries और Leads पाएँ।",
    },
  },
  {
    id: "visible",
    image: "/images/loki/loki_visible.png",
    en: {
      title: "Stay Visible Every Day",
      body: "Stay visible with regular offers, updates and announcements.",
    },
    te: {
      title: "రోజూ కనిపించండి… గుర్తుండిపోండి!",
      body: "మీ ఆఫర్లు, కొత్త స్టాక్, ప్రత్యేక సేవలు, అప్‌డేట్లను కస్టమర్లకు ఎప్పటికప్పుడు తెలియజేయండి.",
    },
    hi: {
      title: "रोज़ दिखिए… याद बने रहिए!",
      body: "ऑफ़र, नया स्टॉक, खास सेवाएँ और अपडेट ग्राहकों तक समय-समय पर पहुँचाएँ।",
    },
  },
  {
    id: "manage",
    image: "/images/loki/loki_manage.png",
    en: {
      title: "Manage Your Business Smarter",
      body: "Manage bills, dues, stock, orders and daily business with ease.",
    },
    te: {
      title: "వ్యాపారాన్ని స్మార్ట్‌గా నడపండి!",
      body: "బిల్లులు, బాకీలు, స్టాక్, ఆర్డర్లు—మీ వ్యాపారాన్ని మరింత సులభంగా నిర్వహించండి.",
    },
    hi: {
      title: "बिज़नेस को स्मार्ट तरीके से चलाएँ!",
      body: "बिल, बकाया, स्टॉक, ऑर्डर—अपना बिज़नेस और आसानी से मैनेज करें।",
    },
  },
  {
    id: "loyal",
    image: "/images/loki/loki_loyal.png",
    en: {
      title: "Build Loyal Customers",
      body: "Keep customers connected and turn them into loyal repeat customers.",
    },
    te: {
      title: "ఒక్కసారి వచ్చిన కస్టమర్… మళ్లీ మళ్లీ రావాలి!",
      body: "ఆఫర్లు, అప్‌డేట్లు, పోల్స్ ద్వారా మీ కస్టమర్లతో ఎప్పటికీ కనెక్ట్‌గా ఉండండి.",
    },
    hi: {
      title: "एक बार आया ग्राहक… बार-बार आए!",
      body: "ऑफ़र, अपडेट और पोल से अपने ग्राहकों से हमेशा जुड़े रहें।",
    },
  },
  {
    id: "compete",
    image: "/images/loki/loki_compete.png",
    en: {
      title: "Compete with Bigger Brands",
      body: "Build a strong digital presence without expensive websites or advertising.",
    },
    te: {
      title: "పెద్ద బ్రాండ్లతో పోటీకి మీ వ్యాపారం కూడా రెడీ!",
      body: "ఖరీదైన వెబ్‌సైట్‌లు, ప్రకటనలు లేకుండానే మీ స్థానిక వ్యాపారానికి డిజిటల్ గుర్తింపు తెచ్చుకోండి.",
    },
    hi: {
      title: "बड़े ब्रांड्स से मुकाबले के लिए आपका बिज़नेस भी तैयार!",
      body: "महंगी वेबसाइट और विज्ञापन के बिना अपने लोकल बिज़नेस की डिजिटल पहचान बनाएँ।",
    },
  },
  {
    id: "allinone",
    image: "/images/loki/loki_allinone.png",
    en: {
      title: "Everything in One Place",
      body: "Visibility, leads, customer communication and business tools—all in one place.",
    },
    te: {
      title: "మీ వ్యాపారానికి కావాల్సినవన్నీ… ఒకే చోట!",
      body: "విజిబిలిటీ, కస్టమర్ లీడ్స్, కమ్యూనికేషన్, బిజినెస్ టూల్స్—అన్నీ Loksyలోనే.",
    },
    hi: {
      title: "बिज़नेस के लिए जो चाहिए… सब एक जगह!",
      body: "विज़िबिलिटी, कस्टमर लीड्स, कम्युनिकेशन, बिज़नेस टूल्स—सब Loksy में ही।",
    },
  },
  {
    id: "grow",
    image: "/images/loki/loki_grow.png",
    en: {
      title: "Grow Your Business",
      body: "Reach more customers, promote your business and grow faster with Loksy.",
    },
    te: {
      title: "చిన్న వ్యాపారం… పెద్ద అవకాశాలు!",
      body: "మరింత మంది కస్టమర్లను చేరుకోండి, మీ వ్యాపారాన్ని ప్రమోట్ చేయండి, Loksyతో మరింత వేగంగా ఎదగండి.",
    },
    hi: {
      title: "छोटा बिज़नेस… बड़े मौके!",
      body: "और ग्राहकों तक पहुँचें, अपना बिज़नेस प्रमोट करें, Loksy के साथ और तेज़ी से बढ़ें।",
    },
  },
  {
    id: "hero",
    image: "/images/loki/loki_hero.png",
    hero: true,
    en: {
      title: "To run your Business… to grow your Business",
      body: "Loksy Vyapar",
    },
    te: {
      title: "మీ Businessని నడపడానికి… మీ Businessని పెంచుకోవడానికి",
      body: "Loksy Vyapar",
    },
    hi: {
      title: "अपना Business चलाने के लिए… अपना Business बढ़ाने के लिए",
      body: "Loksy Vyapar",
    },
  },
];

export const MITRA_STORY_UI = {
  skip: { en: "Skip", te: "దాటవేయి", hi: "छोड़ें" },
  next: { en: "Next", te: "తర్వాత", hi: "आगे" },
  continue: {
    en: "Continue to login",
    te: "లాగిన్‌కి వెళ్లండి",
    hi: "लॉगिन पर जाएँ",
  },
  pageKicker: {
    en: "Loksy Vyapar",
    te: "Loksy Vyapar",
    hi: "Loksy Vyapar",
  },
  pageTitle: {
    en: "Your shop desk. Your growth. One app.",
    te: "మీ షాపు డెస్క్. మీ ఎదుగుదల. ఒకే యాప్.",
    hi: "आपका शॉप डेस्क. आपकी तरक्की. एक ऐप.",
  },
  pageLead: {
    en: "The same splash cards as the Loksy Vyapar app — one card, then the next.",
    te: "Loksy Vyapar యాప్‌లో ఉన్న అదే స్ప్లాష్ కార్డులు — ఒకటి తర్వాత ఒకటి.",
    hi: "Loksy Vyapar ऐप जैसे ही स्प्लैश कार्ड — एक के बाद एक।",
  },
  playCta: {
    en: "Get Loksy Vyapar on Play Store",
    te: "Play Storeలో Loksy Vyapar డౌన్‌లోడ్ చేయండి",
    hi: "Play Store पर Loksy Vyapar डाउनलोड करें",
  },
  webCta: {
    en: "Open Loksy Vyapar dashboard",
    te: "Loksy Vyapar డాష్‌బోర్డ్ తెరవండి",
    hi: "Loksy Vyapar डैशबोर्ड खोलें",
  },
  autoplay: { en: "Autoplay", te: "ఆటోప్లే", hi: "ऑटोप्ले" },
  pause: { en: "Pause", te: "పాజ్", hi: "पॉज़" },
  prev: { en: "Previous", te: "మునుపటి", hi: "पिछला" },
};

export function splashText(screen, lang) {
  return screen[lang];
}
